import { render } from "./FooterMain.vue?vue&type=template&id=706efd32&scoped=true"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"

import "./FooterMain.vue?vue&type=style&index=0&id=706efd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706efd32"]])

export default __exports__